import PropTypes from 'prop-types';
import React from 'react';

import { scsPermissions } from '../../../utils/tab-permissions';
import { PageTemplatePlain } from '../../reusable';

import Main from './Main';

const SCSScheduledChanges = (props) => (
  <PageTemplatePlain
    auth={scsPermissions}
    description="View, edit, or cancel scheduled configuration changes."
    help={(
      <a
        className="ncss-cta-primary-dark underline text-color-secondary"
        href="https://confluence.nike.com/display/RCFITC/RCF+KB+-+SCS+UI"
        rel="noopener noreferrer"
        target="_blank"
      >
        Click here to view the KB
      </a>
    )}
    page={<Main />}
    path={props.location.pathname}
    title="Store Config Service"
  />
);

SCSScheduledChanges.propTypes = {
  location: PropTypes.shape({ pathname: PropTypes.string.isRequired }).isRequired,
};

export default SCSScheduledChanges;
